import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { LanguageService } from 'src/app/ecom-services/ecom-language-service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomItemDetailsPopupComponent } from '../ecom-item-details-popup/ecom-item-details-popup.component';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';

@Component({
  selector: 'app-ecom-item-upsell',
  templateUrl: './ecom-item-upsell.component.html',
  styleUrls: ['./ecom-item-upsell.component.scss']
})
export class EcomItemUpsellComponent implements OnInit {
  @Input() itemIds: number[] = [];
  //@Input() handleUpsellItem?: () => void;

  @Output() handleUpsellItem: EventEmitter<any> = new EventEmitter();

  modalAddToCartRef: BsModalRef;
  upSellItems: any[] = [];
  defaultImage: string = './assets/images/Itemdefault.jpeg';
  settings: any;
  locationSelected: any;

  userServiceBase: UserServiceBase;
  userSelectedStore: StoreServiceBase;
  itemDetailsModal: ItemBase;


  bsModalRef: BsModalRef;
  onClose: any;
  item_pkid: any;
  iscvsd_pkid: any;
  upSellId: any;
  drawerVisible: boolean = false;
  constructor(private webstorage: EComWebStorage, public ecomservice: EComService,
    private modalService: BsModalService, public router: Router,
    private languageService: LanguageService,
    private cartService: EcomCartService,
    private settingService: EcomSettingService
  ) {
    //this.itemDetailsModal = new ItemBase();
  }

  ngOnInit() {
    this.settings = this.webstorage.sessionSt_settings;
    this.locationSelected = this.settingService.getCompanySetting();
    this.userServiceBase = this.webstorage.localSt_user_service_request;
    this.fetchUpsellItems(this.itemIds);
  }

  fetchUpsellItems(itemIds: number[]) {
    const companyId = this.settings.company_id;
    const locationPkid = this.locationSelected.oocls_location_pkid;
    this.ecomservice.httpPost(`${EcomNetworkUtils.GET_ITEMS_UPSELL_BY_IDS}`, { companyId: companyId, ids: itemIds, locationPkid: locationPkid }, '', false)
      .subscribe(response => {
        if (response.status === 200) {
          this.upSellItems = response.listValues;
        }
      });
  }

  addItemToCartOld(item) {
    debugger
    const modalOptions = {
      containerClass: 'diem-test',
      class: 'detail-modal col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12',
      initialState: {
        onClose: this.hideModal.bind(this),
        item_pkid: item.item_pkid,
        iscvsd_pkid: item.iscvsd_pkid,
        upSellId: item.iuic_pkid
      },
      backdrop: true,
      ignoreBackdropClick: true

    };
    this.bsModalRef = this.modalService.show(EcomItemDetailsPopupComponent, modalOptions);
  }

  //drawer
  addItemToCart(item) {
    this.drawerVisible = true;
    this.onClose = this.onDrawerVisibleChange.bind(this);
    this.item_pkid = item.item_pkid;
    this.iscvsd_pkid = item.iscvsd_pkid;
    this.upSellId = item.iuic_pkid;

  }

  onDrawerVisibleChange($event) {
    this.drawerVisible = false;
    this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.oocls_location_pkid);
    this.handleUpsellItem.emit();
  }
  hideModal() {
    this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.oocls_location_pkid);
    this.handleUpsellItem.emit();
    this.bsModalRef.hide();
  }

  onAddToCartClickModal(item) {
    // this.onAddToCartClick(item, false);
    this.closeAddItemToCart();
  }

  closeAddItemToCart() {
    //$('.modal').css({"display": "none"});
    this.modalAddToCartRef.hide();
  }


}
